module.exports = __webpack_public_path__ + "static/media/schedule.9883f5eb.svg";